import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { HubFeature } from '@ats/api/cm';

const columnHeadingDescriptionStart = 'Column heading for: ';
const pathStart = 'Catalogs|Fulfillment|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.OtherRequirement,
	portal: 'SP',
};
type LocNameStart = 'SPOtherRequirementCatalog';

export type SPOtherRequirementCatalogLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}LabelType`
	| `${LocNameStart}LabelFilterByType`
	| `${LocNameStart}LabelGroup`
	| `${LocNameStart}LabelFilterByGroup`
	| `${LocNameStart}LabelId`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelStartDate`
	| `${LocNameStart}LabelEndDate`
	| `${LocNameStart}LabelValidMonths`
	| `${LocNameStart}LabelSingleUse`
	| `${LocNameStart}LabelCreateType`
	| `${LocNameStart}LabelBadgingEnabled`
	| `${LocNameStart}LabelMaxPoints`
	| `${LocNameStart}LabelPoints`
	| `${LocNameStart}LabelFactorUnits`
	| `${LocNameStart}LabelFactor`
	| `${LocNameStart}ContentForever`
	| `${LocNameStart}ButtonCriteria`
	| `${LocNameStart}LabelExternalId`;

export const spOtherRequirementCatalogLocs: LocDefs<SPOtherRequirementCatalogLocNames> = {
	SPOtherRequirementCatalogTitlePage: {
		defaultValue: 'Other Requirements Catalog',
		description: 'Page Title.',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'OtherRequirement/Catalogs.OtherRequirements.Title.PageTitle',
		...sharedProperties,
	},
	SPOtherRequirementCatalogLabelType: {
		defaultValue: 'Type',
		description: `${columnHeadingDescriptionStart}Type`,
		displayPath: `${pathStart}Type`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Catalogs.OtherRequirements.ColumnHeading.Type',
		...sharedProperties,
	},
	SPOtherRequirementCatalogLabelFilterByType: {
		defaultValue: 'Filter by Type',
		description: `Label for: Filter by Type`,
		displayPath: `${pathStart}Filter by Type`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Catalogs.OtherRequirements.Label.TypeFilter',
		...sharedProperties,
	},
	SPOtherRequirementCatalogLabelGroup: {
		defaultValue: 'Group',
		description: `${columnHeadingDescriptionStart}Group`,
		displayPath: `${pathStart}Group`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Catalogs.OtherRequirements.ColumnHeading.Group',
		...sharedProperties,
	},
	SPOtherRequirementCatalogLabelFilterByGroup: {
		defaultValue: 'Filter by Group',
		description: `Label for: Filter by Group`,
		displayPath: `${pathStart}Filter by Group`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Catalogs.OtherRequirements.Label.GroupFilter',
		...sharedProperties,
	},
	SPOtherRequirementCatalogLabelId: {
		defaultValue: 'ID',
		description: `${columnHeadingDescriptionStart}ID`,
		displayPath: `${pathStart}ID`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Catalogs.OtherRequirements.ColumnHeading.ID',
		...sharedProperties,
	},
	SPOtherRequirementCatalogLabelName: {
		defaultValue: 'Name',
		description: `${columnHeadingDescriptionStart}Name`,
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Catalogs.OtherRequirements.ColumnHeading.Name',
		...sharedProperties,
	},
	SPOtherRequirementCatalogLabelStartDate: {
		defaultValue: 'Start Date',
		description: `${columnHeadingDescriptionStart}Start Date`,
		displayPath: `${pathStart}Start Date`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Catalogs.OtherRequirements.ColumnHeading.StartDate',
		...sharedProperties,
	},
	SPOtherRequirementCatalogLabelEndDate: {
		defaultValue: 'End Date',
		description: `${columnHeadingDescriptionStart}End Date`,
		displayPath: `${pathStart}End Date`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Catalogs.OtherRequirements.ColumnHeading.EndDate',
		...sharedProperties,
	},
	SPOtherRequirementCatalogLabelValidMonths: {
		defaultValue: 'Valid Months',
		description: `${columnHeadingDescriptionStart}Valid Months`,
		displayPath: `${pathStart}Valid Months`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Catalogs.OtherRequirements.ColumnHeading.ValidMonths',
		...sharedProperties,
	},
	SPOtherRequirementCatalogLabelSingleUse: {
		defaultValue: 'Single Use',
		description: `${columnHeadingDescriptionStart}Single Use`,
		displayPath: `${pathStart}Single Use`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Catalogs.OtherRequirements.ColumnHeading.SingleUse',
		...sharedProperties,
	},
	SPOtherRequirementCatalogLabelCreateType: {
		defaultValue: 'Create Type',
		description: `${columnHeadingDescriptionStart}Create Type`,
		displayPath: `${pathStart}Create Type`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Catalogs.OtherRequirements.ColumnHeading.CreateType',
		...sharedProperties,
	},
	SPOtherRequirementCatalogLabelBadgingEnabled: {
		defaultValue: 'Badging Enabled',
		description: `${columnHeadingDescriptionStart}Badging Enabled`,
		displayPath: `${pathStart}Badging Enabled`,
		displayType: 'Label',
		legacyName: 'Share.CertMetricsBadging/Catalogs.OtherRequirements.ColumnHeading.BadgingEnabled',
		...sharedProperties,
	},
	SPOtherRequirementCatalogLabelMaxPoints: {
		defaultValue: 'Max Points',
		description: `${columnHeadingDescriptionStart}Max Points`,
		displayPath: `${pathStart}Max Points`,
		displayType: 'Label',
		legacyName: 'Credential.ContinuingEducation/Catalogs.OtherRequirements.FieldLabel.MaxPoints',
		...sharedProperties,
	},
	SPOtherRequirementCatalogLabelPoints: {
		defaultValue: 'Points',
		description: `${columnHeadingDescriptionStart}Points`,
		displayPath: `${pathStart}Points`,
		displayType: 'Label',
		legacyName: 'Credential.ContinuingEducation/Catalogs.OtherRequirements.FieldLabel.Points',
		...sharedProperties,
	},
	SPOtherRequirementCatalogLabelFactorUnits: {
		defaultValue: 'Factor Units',
		description: `${columnHeadingDescriptionStart}Factor Units`,
		displayPath: `${pathStart}Factor Units`,
		displayType: 'Label',
		legacyName: 'Credential.ContinuingEducation/Catalogs.OtherRequirements.FieldLabel.FactorUnits',
		...sharedProperties,
	},
	SPOtherRequirementCatalogLabelFactor: {
		defaultValue: 'Factor',
		description: `${columnHeadingDescriptionStart}Factor`,
		displayPath: `${pathStart}Factor`,
		displayType: 'Label',
		legacyName: 'Credential.ContinuingEducation/Catalogs.OtherRequirements.FieldLabel.Factor',
		...sharedProperties,
	},
	SPOtherRequirementCatalogContentForever: {
		defaultValue: 'Forever',
		description: 'Message shown when the valid period is forever.',
		displayPath: `${pathStart}Forever`,
		displayType: 'Content',
		legacyName: 'OtherRequirement/Catalogs.OtherRequirement.Details.Content.ValidForever',
		...sharedProperties,
	},
	SPOtherRequirementCatalogButtonCriteria: {
		defaultValue: 'Criteria',
		description: 'Button text for Criteria.',
		displayPath: `${pathStart}Criteria`,
		displayType: 'Button',
		legacyName: 'OtherRequirement.InformationUrl/Catalogs.OtherRequirements.Button.Criteria',
		...sharedProperties,
	},
	SPOtherRequirementCatalogLabelExternalId: {
		defaultValue: 'External ID',
		description: `${columnHeadingDescriptionStart}External ID`,
		displayPath: `${pathStart}External ID`,
		displayType: 'Label',
		...sharedProperties,
	},
};

export type SPFulfillmentCatalogLocType = LocMap<SPOtherRequirementCatalogLocNames>;
